export function getHeaderTotalPageCount(response, per_page) {
  let total = parseInt(response.headers["x-total-count"]);
  return Math.ceil(total / per_page);
}
